var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMap = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 31,
    rx: 2.5,
    fill: "#FAFAFA",
    stroke: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7528 9.18541L13.2 11.85C13.0741 11.9444 13 12.0926 13 12.25V22C13 22.412 13.4704 22.6472 13.8 22.4L16.7528 20.1854C16.9043 20.0718 17.107 20.0535 17.2764 20.1382L22.7236 22.8618C22.893 22.9465 23.0957 22.9282 23.2472 22.8146L26.8 20.15C26.9259 20.0556 27 19.9074 27 19.75V10C27 9.58798 26.5296 9.35279 26.2 9.6L23.2472 11.8146C23.0957 11.9282 22.893 11.9465 22.7236 11.8618L17.2764 9.1382C17.107 9.0535 16.9043 9.07178 16.7528 9.18541Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9V20",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12V23",
    stroke: "#333333",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map.93f7fa4ee3c7f26dfe4af6fe98459d88.svg";